import { render } from "./RiskApplicationBtn.vue?vue&type=template&id=42c1f676"
import script from "./RiskApplicationBtn.vue?vue&type=script&lang=js"
export * from "./RiskApplicationBtn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RiskApplicationBtn.vue?vue&type=style&index=0&id=42c1f676&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__